import styled from "@emotion/styled";
import { MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH } from "constants/vp-sizes";
import { LAYER_TWO } from "constants/z-index";
export const StyledMondayDemoTabsMobileComponent = styled.div`
  max-width: ${MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH}px;
  margin: auto;

  .monday-demo-tabs-assets-wrapper {
    position: relative;
    .monday-demo-tabs-asset-click-wrapper {
      .monday-demo-tabs-asset-back-click-wrapper {
        content: "";
        position: absolute;
        top: 0;
        height: 100%;
        width: 60px;
        background: transparent;
        z-index: ${LAYER_TWO};
      }

      .monday-demo-tabs-asset-wrapper {
        .asset-inner {
          .window-mask {
            padding-left: 0;
            padding-right: 0;

            .window-header {
              border-radius: 0;
            }

            video {
              border-radius: 0;
            }
          }
        }
      }
      .monday-demo-tabs-asset-wrapper.current {
        position: relative;
      }
    }
  }

  .mobile-tabs-navigation {
    overflow-x: auto;
    &::-webkit-scrollbar {
      display: none;
    }
    display: flex;
    gap: 8px;
    padding-left: 16px;
    .tab-nav-button-wrapper {
      display: flex;
      white-space: nowrap;
    }
    &::after {
      content: "";
      padding-right: 16px;
    }
  }
`;
